import { Component, OnInit, Inject, OnDestroy, ChangeDetectorRef } from '@angular/core';
import {
  environment
} from 'src/environments/environment';
import { HttpClient, HttpHeaders } from "@angular/common/http";
@Component({
  selector: 'app-home',
  templateUrl: './home.component.html',
})
export class HomeComponent implements OnInit {


  baseurl: string;
  EmpNameTH: string;
  UserName: string;
  constructor(private httpClient: HttpClient, @Inject('BASE_URL') baseUrl: string) {
    this.baseurl = environment.base_api;
  }

  async ngOnInit() {
    this.UserName = localStorage.getItem("UserName");
  }
}
